// extracted by mini-css-extract-plugin
module.exports = {"link":"page_link__v8rH8","text":"page_text__jhCJM"};